
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class AccordionCard extends Vue {
  @Prop({ type: String, default: '' })
  private readonly title!: string

  @Prop({ type: String, default: null })
  private readonly subtitle!: string

  private show = true

  private toggleVisibility() {
    this.show = !this.show
  }
}
